import type { useTranslations } from 'next-intl';

export const getTemplateAll = (trans: ReturnType<typeof useTranslations>) => {
  return [
    {
      id: 'all',
      name: trans('all'),
    },
  ];
};
